<div id="receiver-picture" class="parent">
  <div class="flex flex-column justify-center align-center" id="ImageInsertionPoint">
    <div class="selectedImageContainer">
      <img id="imageToDisplay" src="" alt="" />
    </div>

    <div *ngIf="!uploaded" class="modal-icon mb-4" style="cursor:pointer;" (click)="trigger()">
      <img src="../../../assets/images/svgs/upload.svg" alt="" />
    </div>

    <input hidden (change)="mimeController($event)" id="inputFile" type="file" accept="image/png, image/jpeg" />

    <div class="z-index-2" *ngIf="!uploadEvidence; else evidenceUpload">
      <div *ngIf="!uploaded" class="text-center">
        <p class="para-body">
          Click the button below to upload a picture of your family
        </p>
        <br>
        <div class="text-center mt-4">
          <button (click)="trigger()" class="ui button basic primary">Upload picture</button>
          <br>
          <!-- <button (click)="noPicturesProvided()" class="ui button basic secondary mini">
          Skip
        </button> -->
          <form class="ui form mt-4">
            <div class="field">
              <div class="ui checkbox">
                <input id="xyxx" (click)="noPicturesProvided()" type="checkbox" tabindex="0">
                <label for="xyxx" style="line-height: 1">We dont want to use our picture</label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <ng-template #evidenceUpload>
      <p class="para-title shrink">
        Click to upload a picture of transfer you made to {{ familyName }}
      </p>
    </ng-template>

    <!-- <p>Click the icon to upload a picture</p> -->
    <small *ngIf="notification">Please upload an image lesser than 2.5mb</small>

    <div class="inner-modal" *ngIf="uploaded">
      <div *ngIf="idontWantToProvidePictures" id="idontWantToProvidePictures"
        class="inner-modal-content flex flex-column align-center justify-center text-center">
        <p class="modal-icon mb-4">
          <img src="../../../assets/images/svgs/alert.svg" alt="" />
        </p>

        <p class="para-body">
          Not providing a picture of your family might affect your chances of receiving help.
        </p>

        <button class="ui button primary basic mt-4" (click)="next()">
          Continue without a picture
        </button>
        <a class="mt-3 link" (click)="hide()">
          Provide picture
        </a>
      </div>

      <div *ngIf="!familyName && !idontWantToProvidePictures"
        class="inner-modal-content flex flex-column align-center justify-center">
        <div class="modal-icon mb-4">
          <img src="../../../assets/images/svgs/checked.svg" alt="" />
        </div>

        <button class="ui button primary basic mt-4" (click)="next()">
          Next
        </button>
        <a class="mt-3 link" (click)="changePicture()">
          Change picture
        </a>
      </div>

      <div *ngIf="familyName" class="inner-modal-content flex flex-column align-center justify-center">
        <div class="modal-icon mb-4">
          <img src="../../../assets/images/svgs/checked.svg" alt="" />
        </div>

        <button class="ui button primary basic mt-4" (click)="uploadEvidenceOfTransfer()">
          Upload evidence
        </button>
        <a class="mt-3 link" (click)="changePicture()">
          Change picture
        </a>
      </div>
    </div>
  </div>
</div>